<template>
  <div style="text-align: center">
    <device v-bind="$data">
      <slot name="close"></slot>
      <div
        style="margin: auto;width: 100%;height: 100%;border: 1px solid #eee;overflow: hidden; position: relative;background: white;box-shadow: rgba(0, 0, 0, 0.21) 0px 5px 15px 0px;margin-bottom: 10px; border-radius: 5px"
      >
        <div
          style="width:100%;min-height: 64px;border-bottom: 1px solid #eee;background: url('/static/img/assets/_global/fb_header_bg.png');    background-position: center;background-repeat: no-repeat;background-size: cover;"
        >
          <div
            style="padding-top: 28px;text-align: left;font-size: 10px; margin-left: 30px;float: left"
          >
            <div style="float: left">
              <img
                v-if="selectedBot"
                :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=300&height=300'"
                alt
                style=" margin-left: 10px;width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;"
              />
            </div>
            <div style="float: left">
              <div
                class="text-truncate"
                style="color: black;font-weight: 600;max-width: 100px"
              >{{pagename | truncate(13)}}</div>
              <div class="small">{{$t('Typically replies instantly')}}</div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>

        <div
          style="height: calc(100% - 66px); overflow-x: hidden; overflow-y: auto"
          @scroll="$emit('onScroll',$event)"
        >
          <slot name="body"></slot>
        </div>
        <div style="position: absolute;bottom: 0;right: 0;left: 0;">
          <slot name="footer"></slot>
        </div>
      </div>
    </device>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import device from 'vue-and-devices-mocks'
export default {
  components: {
    device
  },
  data: function() {
    return {
      type: 'iphone',
      scale: 17,
      width: null,
      height: null,
      skins: ['noShadow', 'inverted']
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  props: ['pagename']
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/FacebookScreen.vue